import { reactQueryClient } from '@/utils/reactQueryClient';
import { GET_HCP_VERIFICATIONS_QUERY_KEY } from './hcp-verification-query-key';

export const invalidateHcpVerificationStatus = () =>
  reactQueryClient.invalidateQueries({
    queryKey: [GET_HCP_VERIFICATIONS_QUERY_KEY],
  });
